import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=31f8ebd6&"
import script from "./ProfileCard.vue?vue&type=script&lang=js&"
export * from "./ProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31f8ebd6')) {
      api.createRecord('31f8ebd6', component.options)
    } else {
      api.reload('31f8ebd6', component.options)
    }
    module.hot.accept("./ProfileCard.vue?vue&type=template&id=31f8ebd6&", function () {
      api.rerender('31f8ebd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/profile-card/ProfileCard.vue"
export default component.exports